import { getIdentityToken } from 'lib';
import { STORAGE } from 'utils';

const {
  HEADER: {
    DEFAULT: { AUTHORIZATION: DEFAULT_AUTHORIZATION },
  },
} = STORAGE;

const getAuthorizationHeaders = async (): Promise<HeadersInit> => {
  const headers: HeadersInit = {};

  try {
    const { tokenType, accessToken } = await getIdentityToken();

    if (!tokenType || !accessToken) return headers;

    headers[DEFAULT_AUTHORIZATION] = `${tokenType} ${accessToken}`;
  } catch (error) {
    console.error('Failed to get authorization headers:', error);
  }

  return headers;
};

export { getAuthorizationHeaders };
